<template>
  <b-modal ref="modal"
           size="xl"
           content-class="custom-modal-content"
           no-close-on-esc
           no-close-on-backdrop
           @hide="$emit('hide')"
           @shown="onShow"
           >
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.COPType.Montage.Title}}
        </span>
        <button class="close" @click="$refs.modal.hide()">x</button>
      </div>
    </template>
    <div class="d-flex flex-column h-100">
      <div class="d-flex flex-wrap">
        <b-form-group :label="$lang.PCI.COPType.LabelName">
          <b-form-input disabled v-model="copType.nome" class="mr-3" style="width: max-content;"></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.COPType.LabelDescription">
          <div class="my-2">
            <strong>{{ copType.descricao }}</strong>
          </div>
        </b-form-group>
        <b-button variant="third" v-if="isEmptySelected && !copyClicked" class="m-3" @click="copyClicked = true"><i class="fas fa-copy"></i> {{ $lang.PCI.COPType.Montage.LabelCopy }}</b-button>
        <b-form-group v-if="copyClicked" :label="$lang.PCI.COPType.Montage.LabelCopy" class="flex-grow-1 mx-3">
          <div class="d-flex w-100">
            <v-select :options="typeList" :getOptionLabel="param => param.nome + ' > ' + param.descricao" v-model="selectedType" :selectable="param => param.id !== copType.id" class="w-100"></v-select>
            <i class="fas fa-copy text-third pointer m-2" style="font-size: 1.5rem;" v-if="selectedType" @click="onCopy"></i>
            <i class="fas fa-times text-danger pointer m-2" style="font-size: 1.5rem;" v-if="!selectedType" @click="copyClicked = false"></i>
          </div>
        </b-form-group>
      </div>
      <div class="d-flex flex-wrap align-items-center mb-3">
      </div>
      <div class="d-flex flex-wrap h-100">
        <b-card class="d-flex flex-grow-1 mb-0">
          <template #header><strong>{{$lang.PCI.COPType.Montage.LabelServices}}</strong></template>
          <div class="d-flex flex-wrap">
            <span class='pr-2' style="width: 40%;">{{$lang.PCI.COPType.Montage.LabelAvailable}}</span>
            <span class='pl-2' style="width: 60%;">{{$lang.PCI.COPType.Montage.LabelSelected}}</span>
          </div>
          <div id="serv-div" class="d-flex w-100 h-100">
            <ag-grid-vue id="serv-available-grid"
                        class="ag-theme-alpine h-100 pr-2 available-items"
                        style="width: 40%;"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="servAvailableGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="availableColumnDefs"
                        :rowData="itemsServAvailable"
                        :getRowId="params => params.data.id"
                        :suppressRowClickSelection="true"
                        :suppressHorizontalScroll="true"
                        @gridReady="onGridReady($event, 'serv', 'available')">
            </ag-grid-vue>
            <ag-grid-vue id="serv-selected-grid"
                        class="ag-theme-alpine h-100 pl-2 selected-items"
                        style="width: 60%;"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="servSelectedGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="selectedColumnDefs"
                        :getRowId="params => params.data.id"
                        :rowDragManaged="true"
                        :suppressRowClickSelection="true"
                        :suppressHorizontalScroll="true"
                        :stopEditingWhenCellsLoseFocus="true"
                        @cell-editing-started="editing = true"
                        @cell-editing-stopped="editing = false"
                        :rowClassRules="{'zero-days': 'data.dias === 0'}"
                        @rowDragEnd="onReorganize"
                        @cellValueChanged="onEdit"
                        @gridReady="onGridReady($event, 'serv', 'selected')">
            </ag-grid-vue>
          </div>
        </b-card>
        <!-- Separador -->
        <span class="m-2"></span>
        <b-card class="d-flex flex-grow-1 mb-0">
          <template #header><strong>{{$lang.PCI.COPType.Montage.LabelDocumentation}}</strong></template>
          <div class="d-flex flex-wrap">
            <span class='pr-2' style="width: 60%;">{{$lang.PCI.COPType.Montage.LabelSelected}}</span>
            <span class='pl-2' style="width: 40%;">{{$lang.PCI.COPType.Montage.LabelAvailable}}</span>
          </div>
          <div id="doc-div" class="d-flex w-100 h-100">
            <ag-grid-vue id="doc-selected-grid"
                        class="ag-theme-alpine h-100 pr-2 selected-items"
                        style="width: 60%;"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="docSelectedGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="selectedColumnDefs"
                        :getRowId="params => params.data.id"
                        :rowDragManaged="true"
                        :suppressRowClickSelection="true"
                        :suppressHorizontalScroll="true"
                        @cell-editing-started="editing = true"
                        @cell-editing-stopped="editing = false"
                        :stopEditingWhenCellsLoseFocus="true"
                        :rowClassRules="{'zero-days': 'data.dias === 0'}"
                        @rowDragEnd="onReorganize"
                        @gridReady="onGridReady($event, 'doc', 'selected')">
            </ag-grid-vue>
            <ag-grid-vue id="doc-available-grid"
                        class="ag-theme-alpine h-100 pl-2 available-items"
                        style="width: 40%;"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="docAvailableGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="availableColumnDefs"
                        :rowData="itemsDocAvailable"
                        :getRowId="params => params.data.id"
                        :suppressRowClickSelection="true"
                        :suppressHorizontalScroll="true"
                        @cellValueChanged="onEdit"
                        @gridReady="onGridReady($event, 'doc', 'available')">
            </ag-grid-vue>
          </div>
        </b-card>
      </div>
    </div>
    <template #modal-footer>
      <div class="d-flex">
        <b-button variant="third" :disabled="!hasChange" @click="onSave"><i class="fas fa-save"></i> {{ $lang.Common.Buttons.Save }}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import COPItemRepository from '@/shared/http/repositories/pci/copitem'
import COPTypeItemRepository from '@/shared/http/repositories/pci/coptypeitem'
import CompanyMixin from '@/store/module/company/mixin'
import { loading, toast } from '@/shared/utils/UIHelper'
import { empty } from 'uuidv4'
import ActionsCellRenderer from './actionsCellRenderer.vue'

export default {
  name: 'Montage',
  mixins: [gridMixin, CompanyMixin],
  components: {
    AgGridVue,
    ActionsCellRenderer
  },
  props: {
    copType: {
      type: Object,
      required: true
    },
    typeList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      hasChange: false,
      copyClicked: false,
      selectedType: null,
      isEmptySelected: true,
      editing: false,
      itemsAll: [],
      itemsSelected: [],
      itemsServAvailable: [],
      itemsDocAvailable: [],
      servAvailableGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          suppressMovable: true,
          lockVisible: true
        }
      },
      servSelectedGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          menuTabs: [],
          suppressMovable: true,
          lockVisible: true
        }
      },
      docAvailableGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          suppressMovable: true,
          lockVisible: true
        }
      },
      docSelectedGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          menuTabs: [],
          suppressMovable: true,
          lockVisible: true
        }
      },
      availableColumnDefs: [
        {
          headerName: 'Cód.',
          field: 'codigo',
          type: 'integerColumn',
          width: 30,
          minWidth: 10,
          rowDrag: true
        },
        {
          headerName: 'Descrição',
          field: 'descricao',
          type: 'textColumn',
          width: 100
        }
      ],
      selectedColumnDefs: [
        {
          headerName: 'Cód.',
          field: 'codigo',
          type: 'integerColumn',
          width: 30,
          minWidth: 10,
          rowDrag: true
        },
        {
          headerName: 'Descrição',
          field: 'descricao',
          type: 'textColumn',
          width: 100
        },
        {
          headerName: 'Pos.',
          field: 'posicao',
          type: 'integerColumn',
          width: 20,
          minWidth: 10
        },
        {
          headerName: 'D+',
          field: 'dias',
          type: 'integerColumn',
          width: 30,
          minWidth: 10,
          editable: true
        },
        {
          cellRenderer: 'ActionsCellRenderer',
          cellRendererParams: {
            onClick: this.onClickDelete
          },
          width: 15,
          minWidth: 15
        }
      ]
    }
  },
  methods: {
    show () {
      loading.push()
      this.$refs.modal.show()
      this.$nextTick(() => {
        COPTypeItemRepository.GetAll(this.copType.id)
          .then(response => {
            if (response.data.code > 0) {
              this.itemsSelected = response.data.data
              const itemsDocSelected = response.data.data.filter(i => i.copItem.tipo === 2).map(i => {
                var obj = i.copItem
                obj.posicao = i.posicao
                obj.dias = i.dias
                return obj
              })
              this.docSelectedGridOptions.api.applyTransaction({add: itemsDocSelected})
              const itemsServSelected = response.data.data.filter(i => i.copItem.tipo === 1).map(i => {
                var obj = i.copItem
                obj.posicao = i.posicao
                obj.dias = i.dias
                return obj
              })
              this.servSelectedGridOptions.api.applyTransaction({add: itemsServSelected})
              this.emptySelected()
            } else {
              throw new Error(response.data.message)
            }
          })
          .catch(err => {
            console.log(err)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .then(() => {
            COPItemRepository.GetAll(this.company.id, {params: {inativos: true}})
              .then(response => {
                if (response.data.code > 0) {
                  this.itemsAll = response.data.data
                  this.itemsDocAvailable = response.data.data.filter(i => i.tipo === 2 && i.status === 1 && !this.itemsSelected.some(s => s.copItemID === i.id))
                  this.itemsServAvailable = response.data.data.filter(i => i.tipo === 1 && i.status === 1 && !this.itemsSelected.some(s => s.copItemID === i.id))
                  this.$refs.modal.show()
                } else {
                  throw new Error(response.data.message)
                }
              })
              .catch(err => {
                console.log(err)
                toast.error(this.$lang.Common.Alerts.Error)
              })
          })
          .finally(() => loading.close())
      })
    },
    onShow (params) {
      const processEvent = (api) => {
        const currentCell = api.getFocusedCell()
        const finalRowIndex = api.rowModel.getRowCount() - 1

        if (currentCell.rowIndex === finalRowIndex) {
          return
        }

        api.clearFocusedCell()
        api.startEditingCell({
          rowIndex: currentCell.rowIndex + 1,
          colKey: currentCell.column.colId
        })
      }

      params.target.querySelector('#serv-div')
        .addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter' && this.editing) {
            evt.stopPropagation()
            evt.preventDefault()

            processEvent(this.servSelectedGridOptions.api)
          }
        })

      params.target.querySelector('#doc-div')
        .addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter' && this.editing) {
            evt.stopPropagation()
            evt.preventDefault()

            processEvent(this.docSelectedGridOptions.api)
          }
        })
    },
    onEdit (params) {
      this.hasChange = true
      this.emptySelected()
      params.api.refreshCells({force: true})
    },
    onCopy () {
      loading.push()
      COPTypeItemRepository.GetAll(this.selectedType.id)
        .then(response => {
          if (response.data.code > 0) {
            const itemsDocSelected = response.data.data.filter(i => i.copItem.tipo === 2).map(i => {
              var obj = i.copItem
              obj.posicao = i.posicao
              obj.dias = i.dias
              return obj
            })
            this.docSelectedGridOptions.api.applyTransaction({add: itemsDocSelected})
            const itemsServSelected = response.data.data.filter(i => i.copItem.tipo === 1).map(i => {
              var obj = i.copItem
              obj.posicao = i.posicao
              obj.dias = i.dias
              return obj
            })
            this.servSelectedGridOptions.api.applyTransaction({add: itemsServSelected})
            this.itemsDocAvailable = this.itemsDocAvailable.filter(i => !response.data.data.some(d => d.copItemID === i.id))
            this.itemsServAvailable = this.itemsServAvailable.filter(i => !response.data.data.some(d => d.copItemID === i.id))
            this.copyClicked = false
            this.hasChange = true
            this.emptySelected()
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onSave () {
      loading.push()
      const items = []
      const createObj = item => {
        const selected = this.itemsSelected.filter(sel => sel.copItemID === item.id)[0]
        const obj = {
          id: selected ? selected.id : empty(),
          copModeloID: this.copType.id,
          copItemID: item.id,
          posicao: item.posicao,
          dias: item.dias
        }
        items.push(obj)
      }
      this.servSelectedGridOptions.api.forEachNode(node => {
        createObj(node.data)
      })
      this.docSelectedGridOptions.api.forEachNode(node => {
        createObj(node.data)
      })
      COPTypeItemRepository.Update(this.copType.id, items)
        .then(response => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$refs.modal.hide()
          } else {
            throw new Error()
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    emptySelected () {
      let selectedCount = 0
      if (this.servSelectedGridOptions.api) {
        this.servSelectedGridOptions.api.forEachNode(() => selectedCount++)
      }
      if (this.docSelectedGridOptions.api) {
        this.docSelectedGridOptions.api.forEachNode(() => selectedCount++)
      }
      this.isEmptySelected = selectedCount === 0
    },
    onClickDelete (params) {
      if (params.data.tipo === 1) {
        this.servSelectedGridOptions.api.applyTransaction({remove: [params.data]})
        const item = this.itemsAll.filter(i => i.id === params.data.id)[0]
        if (item.status === 1) {
          this.itemsServAvailable.push(item)
          this.itemsServAvailable.sort((first, second) => first.codigo - second.codigo)
        }
      }
      if (params.data.tipo === 2) {
        this.docSelectedGridOptions.api.applyTransaction({remove: [params.data]})
        const item = this.itemsAll.filter(i => i.id === params.data.id)[0]
        if (item.status === 1) {
          this.itemsDocAvailable.push(item)
          this.itemsDocAvailable.sort((first, second) => first.codigo - second.codigo)
        }
      }
      this.onReorganize(params)
    },
    onReorganize (params) {
      let pos = 1
      params.api.forEachNode(node => {
        node.setDataValue('posicao', pos++)
        if (!node.data.dias) {
          node.setDataValue('dias', 0)
        }
      })
    },
    onStopEdigingDays (params) {
      if (this.evaluationPressEnter) {
        const currentCell = this.itemsEvaluationDataGridOptions.api.getFocusedCell()
        const finalRowIndex = this.itemsEvaluationDataGridOptions.api.rowModel.getRowCount() - 1

        if (currentCell.rowIndex === finalRowIndex) {
          this.itemsEvaluationDataGridOptions.api.setFocusedCell(currentCell.rowIndex, currentCell.column)
          return
        }

        var qt = this.itemsEvaluationDataGridOptions.api.rowModel.getRow(currentCell.rowIndex + 1).data ? 1 : 2

        this.itemsEvaluationDataGridOptions.api.setFocusedCell(currentCell.rowIndex + qt, currentCell.column)
        this.itemsEvaluationDataGridOptions.api.startEditingCell({
          rowIndex: currentCell.rowIndex + qt,
          colKey: currentCell.column
        })
      }
    },
    onGridReady (params, type, position) {
      let sourceGridApi = params.api
      let targetGridApi = null
      params.api.sizeColumnsToFit()
      if (type === 'serv') {
        if (position === 'available') {
          targetGridApi = this.servSelectedGridOptions.api
        }
        if (position === 'selected') {
          targetGridApi = this.servAvailableGridOptions.api
        }
      }
      if (type === 'doc') {
        if (position === 'available') {
          targetGridApi = this.docSelectedGridOptions.api
        }
        if (position === 'selected') {
          targetGridApi = this.docAvailableGridOptions.api
        }
      }
      const dropZoneParams = targetGridApi.getRowDropZoneParams({
        onDragStop: (event) => {
          this.hasChange = true
          if (type === 'serv') {
            if (position === 'available') {
              const index = this.itemsServAvailable.findIndex(i => i.codigo === event.node.data.codigo)
              this.itemsServAvailable.splice(index, 1)
            }
            if (position === 'selected') {
              this.servSelectedGridOptions.api.applyTransaction({remove: [event.node.data]})
              const item = this.itemsAll.filter(i => i.id === event.node.data.id)[0]
              if (item.status === 1) {
                this.itemsServAvailable.push(item)
                this.$nextTick(() => {
                  this.itemsServAvailable.sort((first, second) => first.codigo - second.codigo)
                })
              }
            }
          }
          if (type === 'doc') {
            if (position === 'available') {
              const index = this.itemsDocAvailable.findIndex(i => i.codigo === event.node.data.codigo)
              this.itemsDocAvailable.splice(index, 1)
            }
            if (position === 'selected') {
              this.docSelectedGridOptions.api.applyTransaction({remove: [event.node.data]})
              const item = this.itemsAll.filter(i => i.id === event.node.data.id)[0]
              if (item.status === 1) {
                this.itemsDocAvailable.push(item)
                this.$nextTick(() => {
                  this.itemsDocAvailable.sort((first, second) => first.codigo - second.codigo)
                })
              }
            }
          }
          this.$nextTick(() => {
            this.servAvailableGridOptions.api.sizeColumnsToFit()
            this.servSelectedGridOptions.api.sizeColumnsToFit()
            this.docAvailableGridOptions.api.sizeColumnsToFit()
            this.docSelectedGridOptions.api.sizeColumnsToFit()
            this.emptySelected()
          })
        }
      })

      sourceGridApi.addRowDropZone(dropZoneParams)
    }
  }
}
</script>

<style scoped>
.selected-items.ag-theme-alpine {
  --ag-header-background-color: #008144;
  --ag-header-column-resize-handle-color: #fff0;
}
.available-items.ag-theme-alpine {
  --ag-header-background-color: lightgray;
  --ag-header-foreground-color: gray;
  --ag-header-column-resize-handle-color: #fff0;
}
* >>> .custom-modal-content {
  height: 95vh;
}
 * >>> .zero-days .ag-cell-value {
  font-weight: bolder;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/coptype/montage.vue